import { IProductInfo } from 'main/interfaces';

export const getProductInfoByLang = (info: IProductInfo[] | undefined, language: number | undefined): IProductInfo | undefined => {
    return language && info ? info?.find((item) => item.id_language === language) : undefined;
};
